import pipe from "ramda/src/pipe"

import { safe } from "./fn"
import _isEmpty from "lodash/isEmpty"
import { isNil } from "lodash"

export function numberToReal(numero) {
  numero = parseFloat(numero)
  numero = numero.toFixed(2).split(".")
  numero[0] = numero[0].split(/(?=(?:...)*$)/).join(".")
  return numero.join(",")
}

function validation(value) {
  if (value !== undefined && value !== "") {
    return true
  }
  return false
}

export function maskCPFCPNJ(document) {
  if (!document) return null
  if (document.length === 11) {
    return maskCPF(document)
  }
  return maskCNPJ(document)
}

export function maskCPF(cpf) {
  if (validation(cpf)) {
    cpf = cpf.replace(/\D/g, "")
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2")
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2")
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    return cpf
  }
}

export function mtel(v) {
  if (!v) return null
  if (v[0] === "0") v = v.replace("0", "")
  v = v
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)(\d{4})(\d{4})$/, "($1) $2 $3-$4")
  return v
}

export function maskTel(tel) {
  if (validation(tel)) {
    tel = tel.replace(/\D/g, "")
    tel = tel.replace(/(\d{2})(\d)/, "($1) $2")
    tel = tel.replace(/(\d)(\d{4})$/, "$1-$2")
    return tel
  }
}

export function maskTelCustom(tel) {
  if (validation(tel)) {
    if (tel[0] === "0") tel = tel.replace("0", "")
    tel = tel.replace(/\D/g, "")
    tel = tel.replace(/(\d{2})(\d)/, "($1) $2")
    tel = tel.replace(/(\d)(\d{4})$/, "$1-$2")
    return tel
  }
}

export function maskCep(cep) {
  if (validation(cep)) {
    cep = cep.replace(/\D/g, "")
    cep = cep.replace(/(\d{5})(\d)/, "$1-$2")
    return cep
  }
}

export function maskCNPJ(cnpj) {
  if (validation(cnpj)) {
    return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
  }
}

export function removeMaskCPFCNPJ(document) {
  if (!document) return null
  if (document.length === 11) {
    return removeMaskCPF(document)
  }
  return removeMaskCNPJ(document)
}

export function removeMaskCPF(cpf) {
  if (validation(cpf)) {
    cpf = cpf.replace(".", "").replace(".", "").replace("-", "")
    return cpf
  }
}

export function removeMaskTel(tel) {
  if (validation(tel)) {
    return tel.replace(/[\s()-]/g, "")
  }
}

export function removeMaskCNPJ(cnpj) {
  if (validation(cnpj)) {
    if (!_isEmpty(cnpj)) {
      cnpj = cnpj
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")
        .replace("/", "")
    }
    return cnpj
  }
}

export function removeMaskCEP(cep) {
  if (validation(cep)) {
    cep = cep.replace(/\D/g, "")
    cep = cep.replace(/(\d{5})(\d)/, "$1$2")
    return cep
  }
}

export function onlyNumberMask(mixed) {
  return mixed.replace(/\D/g, "")
}

export const handleDocument = (e) => {
  const { name, value } = e.target
  const cleanedValue = value.replace(/\D/g, "")

  let mask
  if (cleanedValue.length <= 11) {
    mask = "999.999.999-99"
  } else {
    mask = "99.999.999/9999-99"
  }

  let formattedValue = ""
  let valueIndex = 0
  for (let maskIndex = 0; maskIndex < mask.length; maskIndex++) {
    if (valueIndex >= cleanedValue.length) {
      break
    }

    if (mask[maskIndex] === "9") {
      formattedValue += cleanedValue[valueIndex]
      valueIndex++
    } else {
      if (cleanedValue[valueIndex] !== mask[maskIndex]) {
        formattedValue += mask[maskIndex]
      } else {
        formattedValue += cleanedValue[valueIndex]
        valueIndex++
      }
    }
  }
  return { name, formattedValue }
}

export const handlePhone = (e) => {
  const { name, value } = e.target
  const cleanedValue = value.replace(/\D/g, "")

  let mask
  if (cleanedValue.length <= 10) {
    mask = "(99) 9999-9999"
  } else {
    mask = "(99) 99999-9999"
  }

  let formattedValue = ""
  let valueIndex = 0
  for (let maskIndex = 0; maskIndex < mask.length; maskIndex++) {
    if (valueIndex >= cleanedValue.length) {
      break
    }

    if (mask[maskIndex] === "9") {
      formattedValue += cleanedValue[valueIndex]
      valueIndex++
    } else {
      formattedValue += mask[maskIndex]
    }
  }

  return { name, formattedValue }
}

//  ----------------------------------------------------------------------------

function numberMask(mixed) {
  if (isNil(mixed)) return ""
  return String(mixed).replace(/\D/g, "")
}

function numberOmbudsmanMask(mixed) {
  return mixed
}

function phoneMask(mixed) {
  return mixed
    .replace(/^(\d{12})(\d+)/g, "$1")
    .replace(/^0/, "")
    .replace(/^(\d{2})(\d+)$/, "$1 $2")
    .replace(/^(\d{2})\s(\d{4})(\d{4})$/, "($1) $2-$3")
    .replace(/^(\d{2})\s(\d)(\d{4})(\d{4})$/, "($1) $2 $3-$4")
    .replace(/^(\d{2})(.+)$/, "($1)$2")
}

function cpfMask(mixed) {
  return mixed
    .replace(/^(.{11})/, "$1")
    .replace(/^(.{3})(\d)/, "$1.$2")
    .replace(/^(.{7})(.+)/, "$1.$2")
    .replace(/^(.{11})(.+)/, "$1-$2")
}

function cnpjMask(mixed) {
  return mixed
    .replace(/^(.{14})/, "$1")
    .replace(/^(.{2})(.+)/, "$1.$2")
    .replace(/^(.{6})(.+)/, "$1.$2")
    .replace(/^(.{10})(.+)/, "$1/$2")
    .replace(/^(.{15})(.+)/, "$1-$2")
}

function dateMask(mixed) {
  return mixed
    .replace(/^(.{8}).*$/, "$1")
    .replace(/^(.{2})(.+)/, "$1/$2")
    .replace(/^(.{5})(.+)$/, "$1/$2")
}

function documentMask(raw) {
  return raw.length > 11 ? cnpjMask(raw) : cpfMask(raw)
}

function algarPhoneMask(mixed) {
  return mixed.replace(/^0?(\d+)$/, "0$1")
}

function algarDateMask(mixed) {
  return mixed.replace(/^(.{10})$/, "$1 00:00:00")
}

function timeMask(mixed) {
  return mixed.replace(/^(.{4}).*$/, "$1").replace(/^(.{2})(.+)/, "$1:$2")
}

function rangeTimeMask(mixed) {
  return mixed
    .replace(/^(.{8}).*$/, "$1")
    .replace(/^(.{2})(.+)/, "$1:$2")
    .replace(/^(.{5})(.+)/, "$1 às $2")
    .replace(/^(.{11})(.+)/, "$1:$2")
}

function protocolMask(mixed) {
  return mixed.replace(/^(.{12})(.{1})/, "$1-$2")
}

function protocolOmbudsmanMask(mixed) {
  return mixed.replace(/^(.{15})(.{1})/, "$1-$2")
}

export function newProtocolMask(mixed) {
  return mixed
}

export function cvvMask(mixed) {
  return mixed.replace(/^(.{3,4}).*$/, "$1")
}

export function monthYearMask(mixed) {
  return mixed.replace(/(\d{2})(\d{2})/, "$1/$2")
}

export function creditCardMask(mixed) {
  return mixed
    .replace(/^(\d{4})(\d+)$/, "$1 $2")
    .replace(/^(\d{4})\s(\d{4})(\d{4})$/, "$1 $2 $3")
    .replace(/^(\d{4})\s(\d{4})(\d{4})(\d+)$/, "$1 $2 $3 $4")
}

function ipMask(mixed) {
  return mixed.replace(/^(([1-9]?\d|1\d\d|2[0-4]\d|25[0-5])(\.(?!$)|$)){4}$/)
}

export const number = pipe(safe, numberMask)

export const phone = pipe(safe, numberMask, phoneMask)

export const cpf = pipe(safe, numberMask, cpfMask)

export const date = pipe(safe, numberMask, dateMask)

export const cnpj = pipe(safe, numberMask, cnpjMask)

export const document = pipe(safe, numberMask, documentMask)

export const algarPhone = pipe(safe, numberMask, algarPhoneMask)

export const algarDate = pipe(safe, numberMask, dateMask, algarDateMask)

export const time = pipe(safe, numberMask, timeMask)

export const protocol = pipe(safe, numberMask, protocolMask)

export const protocolOmbudsman = pipe(
  safe,
  numberOmbudsmanMask,
  protocolOmbudsmanMask
)

export const cvv = pipe(safe, numberMask, cvvMask)

export const ip = pipe(safe, numberMask, ipMask)

export const timeRange = pipe(safe, numberMask, rangeTimeMask)

export const monthYear = pipe(safe, numberMask, monthYearMask)

export const creditCard = pipe(safe, numberMask, creditCardMask)

export const valueMask = (value) => {
  const formattingValue = value
    .replace(/(.*){1}/, "0$1")
    .replace(/[^\d]/g, "")
    .replace(/(\d\d?)$/, ".$1")
  const parsedValue = parseFloat(formattingValue).toFixed(2)
  return parsedValue === "0.00" ? "" : parsedValue
}

export function maskCurrencyBR(value) {
  if (!value) return ""
  const digits = value.replace(/\D/g, "")

  if (!digits) return ""

  const number = parseFloat(digits) / 100

  return number.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}



// WEBPACK FOOTER //
// ./src/services/utils/mask.js